import type { Account } from '@/types/v2/account';
import { AccountTypeLabel } from '@/types/v2/account';
import { Box, Chip, Divider, Paper, Typography } from '@mui/material';
import { PropertyItem } from '@/components/core/v2/property-item';
import { PropertyList } from '@/components/core/v2/property-list';

interface AccountDetailsCardProps {
  account: Account;
}

export function AccountDetailsCard({ account }: AccountDetailsCardProps): React.JSX.Element {
  return (
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <Box sx={{ p: { xs: 2, md: 3 }, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography sx={{ fontWeight: 600 }} variant="subtitle1">
          Account Details
        </Typography>
      </Box>
      <PropertyList divider={<Divider />} orientation="vertical" sx={{ '--PropertyItem-padding': '12px 24px' }}>
        {(
          [
            { key: 'Name', value: account.name },
            { key: 'Type', value: AccountTypeLabel[account.type] },
            ...(account.email
              ? [{ key: 'Contact', value: <Chip label={account.email} size="small" variant="soft" /> }]
              : []),
            ...(account.phone
              ? [{ key: 'Phone', value: <Chip label={account.phone} size="small" variant="soft" /> }]
              : []),
          ] satisfies { key: string; value: React.ReactNode }[]
        ).map(
          (item): React.JSX.Element => <PropertyItem key={item.key} name={item.key} value={item.value} />
        )}
      </PropertyList>
    </Paper>
  );
}
